module.exports = __webpack_public_path__ + "static/img/on1.f0759849.gif";